import {t} from 'i18next';
import {
  EvidenceStatuses,
  EvidenceSubStatus,
} from '../../../constants/constants';

const EVIDENCE_STRING_PATH = 'evidenceSource';

export const getEvidenceStatusString = (status: string | null) => {
  if (!status) return '';

  const stringPath = `${EVIDENCE_STRING_PATH}.evidenceStatus.status.`;
  let key = '';

  switch (status) {
    case EvidenceStatuses.IN_PROCESSING:
    case EvidenceStatuses.PENDING_APPROVAL:
      key = 'Processing';
      break;
    case EvidenceStatuses.MAPPING_DATA:
      key = 'mappingData';
      break;
    case EvidenceStatuses.PROCESSED:
      key = 'processed';
      break;
    case EvidenceStatuses.MAPPING_COMPLETE:
      key = 'mappingComplete';
      break;
    case EvidenceStatuses.PROCESSED_WITH:
      key = 'processedWith';
      break;
    case EvidenceStatuses.PROCESSING_FAILED:
      key = 'processingFailed';
      break;
    case EvidenceStatuses.INTAKE_DATA_COPYING:
      key = 'dataCoping';
      break;
    case EvidenceStatuses.INTAKE_Extraction:
      key = 'intakeExtraction';
      break;
    case EvidenceStatuses.INTAKE_VIRUS_SCANNING:
      key = 'virusScanning';
      break;
    case EvidenceStatuses.INTAKE_COPY_TO_OUTPUT:
      key = 'intakeCopyToOutput';
      break;
    case EvidenceStatuses.INTAKE_BEING_PARSED:
      key = 'intakeBeingParsed';
      break;
    case EvidenceStatuses.INTAKE_BATCHING:
      key = 'intakeBatching';
      break;
    case EvidenceStatuses.INTAKE_PENDING:
      key = 'intakePending';
      break;
    case EvidenceStatuses.IN_PROCESSING_MANUAL:
      key = 'inProcessingManual';
      break;
    case EvidenceStatuses.STAGED:
      key = 'staged';
      break;

    default:
      return '';
  }

  return t(stringPath + key);
};

export const getEvidenceSubStatusString = (subStatus: string | null) => {
  if (!subStatus) return '';

  const stringPath = `${EVIDENCE_STRING_PATH}.evidenceStatus.subStatus.`;
  const value = EvidenceSubStatus[subStatus as keyof typeof EvidenceSubStatus];

  return value ? t(stringPath + value) : '';
};

export const getEvidenceTooltipString = (status: string | null) => {
  if (!status) return '';

  const stringPath = `${EVIDENCE_STRING_PATH}.tooltip.`;

  switch (status) {
    case EvidenceStatuses.IN_PROCESSING:
    case EvidenceStatuses.PENDING_APPROVAL:
      return t(stringPath + 'intakeBatching');
    case EvidenceStatuses.PROCESSING_FAILED:
      return t(stringPath + 'processingFailed');
    case EvidenceStatuses.INTAKE_DATA_COPYING:
      return t(stringPath + 'dataCopying');
    case EvidenceStatuses.INTAKE_Extraction:
      return t(stringPath + 'intakeExtraction');
    case EvidenceStatuses.INTAKE_VIRUS_SCANNING:
      return t(stringPath + 'intakeVirusScanning');
    case EvidenceStatuses.INTAKE_COPY_TO_OUTPUT:
      return t(stringPath + 'intakeCopyToOutput');
    case EvidenceStatuses.INTAKE_BEING_PARSED:
      return t(stringPath + 'intakeBeingParsed');
    case EvidenceStatuses.INTAKE_BATCHING:
      return t(stringPath + 'intakeBatching');
    case EvidenceStatuses.INTAKE_PENDING:
      return t(stringPath + 'intakePending');
    case EvidenceStatuses.IN_PROCESSING_MANUAL:
      return t(stringPath + 'inProcessingManual');
    default:
      return '';
  }
};

// for customize evidence Status
export const EvidenceStatusToLocaleKey: Record<EvidenceStatuses, string> = {
  [EvidenceStatuses.IN_PROCESSING]: 'processing',
  [EvidenceStatuses.PENDING_APPROVAL]: 'pendingApproval',
  [EvidenceStatuses.PROCESSED]: 'processed',

  [EvidenceStatuses.INTAKE_DATA_COPYING]: 'intakeDataCopying',
  [EvidenceStatuses.INTAKE_Extraction]: 'intakeExtraction',
  [EvidenceStatuses.INTAKE_VIRUS_SCANNING]: 'intakeVirusScanning',
  [EvidenceStatuses.INTAKE_COPY_TO_OUTPUT]: 'intakeCopyToOutput',
  [EvidenceStatuses.INTAKE_BEING_PARSED]: 'intakeBeingParsed',
  [EvidenceStatuses.INTAKE_BATCHING]: 'intakeBatching',
  [EvidenceStatuses.INTAKE_PENDING]: 'intakePending',

  [EvidenceStatuses.STAGED]: 'stagedProcessing',
  [EvidenceStatuses.PROCESSING_FAILED]: 'tempHoldEvaluation',

  [EvidenceStatuses.PROCESSED_WITH]: 'processedWith',
  [EvidenceStatuses.MAPPING_DATA]: 'mappingData',
  [EvidenceStatuses.MAPPING_COMPLETE]: 'mappingComplete',
  [EvidenceStatuses.IN_PROCESSING_MANUAL]: 'inProcessingManual',
};
